
/**
 * Table container: sticky thead, only tbody scrolls, no pagination (spec).
 */
export function TableWrapper({
  children,
  maxHeight = 'calc(100vh - 16rem)',
}: {
  children: React.ReactNode;
  maxHeight?: string;
}) {
  return (
    <div className="border border-gray-200 rounded overflow-hidden">
      <div className="overflow-auto" style={{ maxHeight }}>
        <table className="w-full text-sm border-collapse">
          {children}
        </table>
      </div>
    </div>
  );
}

export function TableHead({ children }: { children: React.ReactNode }) {
  return (
    <thead className="sticky top-0 bg-gray-100 border-b border-gray-200 z-10">
      {children}
    </thead>
  );
}

export function FilterRow({ children }: { children: React.ReactNode }) {
  return (
    <tr className="bg-gray-50 border-b border-gray-200">
      {children}
    </tr>
  );
}

